/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeaveRequest } from './LeaveRequest';
import {
    LeaveRequestFromJSON,
    LeaveRequestFromJSONTyped,
    LeaveRequestToJSON,
    LeaveRequestToJSONTyped,
} from './LeaveRequest';

/**
 * 
 * @export
 * @interface ShowLeaveRequestResponse
 */
export interface ShowLeaveRequestResponse {
    /**
     * 
     * @type {LeaveRequest}
     * @memberof ShowLeaveRequestResponse
     */
    data: LeaveRequest;
}

/**
 * Check if a given object implements the ShowLeaveRequestResponse interface.
 */
export function instanceOfShowLeaveRequestResponse(value: object): value is ShowLeaveRequestResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ShowLeaveRequestResponseFromJSON(json: any): ShowLeaveRequestResponse {
    return ShowLeaveRequestResponseFromJSONTyped(json, false);
}

export function ShowLeaveRequestResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowLeaveRequestResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': LeaveRequestFromJSON(json['data']),
    };
}

  export function ShowLeaveRequestResponseToJSON(json: any): ShowLeaveRequestResponse {
      return ShowLeaveRequestResponseToJSONTyped(json, false);
  }

  export function ShowLeaveRequestResponseToJSONTyped(value?: ShowLeaveRequestResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': LeaveRequestToJSON(value['data']),
    };
}

